// src/components/SuperAdminProtectedRoute.jsx - REVISED version preserving all existing functionality
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSuperAdminAuth } from '../contexts/SuperAdminAuthContext';

function SuperAdminProtectedRoute() {
  const { currentSuperAdmin, isSuperAdmin, loading } = useSuperAdminAuth();

  console.log('SuperAdminProtectedRoute - Auth state:', {
    currentSuperAdmin: !!currentSuperAdmin,
    isSuperAdmin,
    loading
  });

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div>
          <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            Loading SuperAdmin Dashboard...
          </div>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #E64C31',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto'
          }}></div>
        </div>
      </div>
    );
  }

  if (!currentSuperAdmin || !isSuperAdmin) {
    console.log('SuperAdminProtectedRoute - Redirecting to login');
    // ENHANCED: Updated redirect path to match your URL structure
    return <Navigate to="/BespokeBeauty/superadmin/login" replace />;
  }

  console.log('SuperAdminProtectedRoute - Allowing access');
  return <Outlet />;
}

export default SuperAdminProtectedRoute;